import { ChangeDetectionStrategy, Component, Inject, Input } from '@angular/core';
import { first } from 'rxjs/operators';

import { AccountFacade } from '@mode/accounts/contract';
import { BreadcrumbTypes } from '@mode/shared/contract-common';
import { OrgTypes } from '@mode/shared/contract-common';
import { NewContainerMenuItem } from '@mode/shared/ui';
import { AnalyticsEvent, PAGE_CONTEXT } from '@mode/shared/util-segment';
import { Observable, map } from 'rxjs';
import { NavMenuService } from '../nav-menu.service';

@Component({
  selector: 'mode-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {
  @Input() workspace: OrgTypes.Organization | null = null;
  @Input() breadcrumbs: BreadcrumbTypes.Breadcrumb[] = [];

  searchFocused = false;
  orgContext$ = this._accountFacade.currentOrg$;
  isLoggedIn$ = this._accountFacade.isLoggedIn$;
  navOpen$ = this._navMenuService.navState();
  newMenuContainerItems$!: Observable<NewContainerMenuItem[]>;
  newReportLink$!: Observable<string>;

  constructor(
    private _accountFacade: AccountFacade,
    private _navMenuService: NavMenuService,
    @Inject(PAGE_CONTEXT) private pageContext: string
  ) {
    this.newReportLink$ = this.orgContext$.pipe(
      first(),
      map(({ username }) => `/editor/${username}/reports/new`)
    );

    this.newMenuContainerItems$ = this.orgContext$.pipe(
      first(),
      map(({ username }) => {
        return [
          {
            href: `/editor/reports/new`,
            text: 'Report',
            icon: 'icon-report-builder',
            class: 'new-report',
            testAttribute: 'create-new-report',
            trackClickData: {
              location: this.pageContext,
              action: AnalyticsEvent.Name.NewReport,
            },
          },
          {
            href: `/editor/${username}/datasets/new`,
            text: 'Dataset',
            icon: 'icon-dataset',
            class: 'new-dataset',
            testAttribute: 'create-new-dataset',
            trackClickData: {
              location: this.pageContext,
              action: AnalyticsEvent.Name.NewDataset,
            },
          },
        ];
      })
    );
  }
  openNav() {
    this._navMenuService.open();
  }
}
